export function parseToNumber(value: string | number | undefined | null, minValue: number = 0): number {
  if (typeof value === 'number') {
    return isNaN(value) ? minValue : Math.max(minValue, value);
  }
  
  if (!value) {
    return minValue;
  }
  
  const parsed = parseFloat(String(value));
  return isNaN(parsed) ? minValue : Math.max(minValue, parsed);
}
